import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environmentCAS';

@Injectable({
  providedIn: 'root'
})
export class SwissLifeService {

  // URL de l'API backend pour SwissLife (d'après SwissLifeTarificationController.java: /api/v1/tarification/swisslife)
  private apiUrl = `${environment.casApiUrl}/api/v1/tarification/swisslife`;

  constructor(private http: HttpClient) { }

  /**
   * Envoie la requête de tarification SwissLife au backend Java
   * @param request Payload au format SwissLifeTarificationRequest
   * @returns Observable de la réponse (contenant les tarifs)
   */
  getSwissLifeTarif(request: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    return this.http.post<any>(this.apiUrl, request, { headers });
  }
}
